import { render, staticRenderFns } from "./MonitorLogs.vue?vue&type=template&id=010449fa&scoped=true"
import script from "./MonitorLogs.vue?vue&type=script&lang=js"
export * from "./MonitorLogs.vue?vue&type=script&lang=js"
import style0 from "./MonitorLogs.vue?vue&type=style&index=0&id=010449fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010449fa",
  null
  
)

export default component.exports